import { reportApi } from '@/api/reportApi';
import ErrorAlert from '@/components/errorAlert';
import { Box, Button, Modal, Progress } from '@mantine/core';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { t } from 'translations';

export const Route = createFileRoute('/_auth/_home/report/$reqId')({
    component: RouteComponent,
});

function RouteComponent() {
    const navigate = useNavigate();
    const { reqId } = Route.useParams();
    const [job, error = job && 'error' in job ? job.error : undefined] =
        reportApi.useReportRequestState(reqId);
    const state = job?.state;
    const { count = 1, done = 0 } = job?.progress ?? {};
    const hasFiles = state === 'completed' && count > 0;

    const [token] = reportApi.reportToken(reqId ?? '').useCache({ disabled: !hasFiles });

    let link;
    if (token) {
        const url = new URL('/api/reports/download', window.location.origin);
        url.searchParams.set('token', token);
        link = url.toString();
    }

    function close() {
        navigate({ to: '/report' });
    }

    if (error) {
        return (
            <Modal opened onClose={close} centered title={t('report.request.error')}>
                <ErrorAlert error={error} />
            </Modal>
        );
    }

    if (job?.state !== 'completed' || (hasFiles && !token)) {
        return (
            <Modal opened onClose={close} centered title={t('report.request.inProgress')}>
                <Box
                    css={{
                        minWidth: 400,
                        display: 'grid',
                        gridTemplateColumns: '1fr max-content',
                        alignItems: 'center',
                        gap: 'var(--mantine-spacing-md)',
                    }}
                >
                    <Progress
                        value={job?.progress ? (done / count) * 100 : 0}
                        animated={!job?.progress}
                    />
                    {job?.progress && (
                        <div>
                            {done} / {count}
                        </div>
                    )}
                </Box>
            </Modal>
        );
    }

    if (!hasFiles) {
        return <Modal opened onClose={close} centered title={t('report.request.noFiles')} />;
    }

    return (
        <Modal opened onClose={close} centered title={t('report.request.ready')}>
            <Button component="a" href={link} download size="lg">
                {t('report.request.download')}
            </Button>
        </Modal>
    );
}
